import { ElevateTheme } from '@wds/styles';
import { HeaderTheme } from '../theme';

const ElevateHeaderTheme: HeaderTheme = {
  background: {
    main: ElevateTheme.palette.background.dark,
  },
  text: {
    main: ElevateTheme.palette.text.light,
  },
  height: 48,

  breakpoints: ElevateTheme.breakpoints,
  palette: ElevateTheme.palette,
  radius: ElevateTheme.radius,
  spacing: ElevateTheme.spacing,
  type: ElevateTheme.type,
};

export { ElevateHeaderTheme };
export default ElevateHeaderTheme;
